import * as yup from 'yup';
import { Material } from 'types';
import { areDatesOnTheSameDay, checkDateLowerTimeInterval, checkDateUpperTimeInterval } from 'utils/date';
import { isMaterialConditionnedInBalls } from 'utils/formValidation';

export const expeditionFormSchema = (
  pt: any,
  materialChoices: Material[] | null,
  closureDate: Date | null,
  twoMonthAfterClosureDate: Date | null,
): yup.AnyObjectSchema =>
  yup.object().shape({
    material: yup.string().required(pt('validation.requiredMaterial')),
    buyer: yup.string().required(pt('validation.requiredBuyer')),
    expeditionDate: yup
      .date()
      .typeError(pt('validation.date.invalid'))
      .nullable()
      .required(pt('validation.date.required'))
      .max(new Date(), pt('validation.date.previousThanToday'))
      .test('alreadyClosedMonth', pt('validation.date.alreadyClosedMonth'), (value, _) =>
        checkDateLowerTimeInterval(value, closureDate),
      )
      .test('datePreviousThanClosure', pt('validation.date.previousThanClosure'), (value, _) =>
        checkDateUpperTimeInterval(value, twoMonthAfterClosureDate),
      ),
    expeditionTime: yup
      .date()
      .typeError(pt('validation.time.invalid'))
      .nullable()
      .required(pt('validation.time.required'))
      .when('expeditionDate', {
        is: (expeditionDate: Date | null) => expeditionDate && areDatesOnTheSameDay(expeditionDate, new Date()),
        then: yup
          .date()
          .typeError(pt('validation.time.invalid'))
          .nullable()
          .max(new Date(), pt('validation.date.previousThanToday')),
      }),
    weight: yup
      .number()
      .transform(value => (isNaN(value) ? undefined : value))
      .required(pt('validation.weight.required'))
      .typeError(pt('validation.weight.invalid'))
      .moreThan(0, pt('validation.weight.invalid')),
    conditioningQuantity: yup
      .number()
      .transform(value => (isNaN(value) ? null : value))
      .nullable()
      .typeError(pt('validation.conditioningQuantity.invalid'))
      .when('material', {
        is: (material: Material | '') => {
          if (!materialChoices) return false;
          let selectedMaterial = materialChoices.find((el: Material) => material === el['@id']);
          return isMaterialConditionnedInBalls(selectedMaterial);
        },
        then: yup
          .number()
          .transform(value => (isNaN(value) ? null : value))
          .nullable()
          .typeError(pt('validation.conditioningQuantity.invalid'))
          .moreThan(0, pt('validation.conditioningQuantity.invalid'))
          .required(pt('validation.conditioningQuantity.required'))
          .test('conditioningQuantity', pt('validation.conditioningQuantity.tooLarge'), function (value) {
            let material = this.parent.material;
            if (!materialChoices) return true;
            let selectedMaterial = materialChoices.find((el: Material) => material === el['@id']);
            if (value && selectedMaterial?.provisionalOutboundStock?.conditioningQuantity) {
              return value <= selectedMaterial.provisionalOutboundStock.conditioningQuantity;
            }
            return true;
          }),
      }),
    truckIdentifier: yup.string().nullable(),
  });
